import { useMutation } from '@gogame/query';

import { downloadErrorFile as source } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';

import { downloadErrorFile as key } from '../queryKeyFactory';

export const useDownloadErrorFile = () => {
  const mutation = useMutation(key(), source, {
    refresh: false,
  });

  const handleAction = async (params) => {
    await mutation.mutateAsync(params);
  };

  return [handleAction, mutation];
};
